// import React from 'react';
// import './CardsSection.scss';


// const CardsSection = () => {
//   return (
//     <div className="cards-section">
//       <div className="card">
//         <h3>Shipped Orders</h3>
//         <p>200</p>
//       </div>
//       <div className="card1">
//         <h3>Pending Orders</h3>
//         <p>50</p>
//       </div>
//       <div className="card2">
//         <h3>New Orders</h3>
//         <p>25</p>
//       </div>
//     </div>
//   );
// };

// export default CardsSection;


import React from 'react';
import './CardsSection.scss';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCartShopping,
  faShippingFast,
  faCartPlus,
} from "@fortawesome/free-solid-svg-icons";

const CardsSection = () => {
  // Data for the cards
  const shippedOrders = 200;
  const pendingOrders = 50;
  const newOrders = 25;

  // Chart data for each card
  const chartData1 = [
    { name: 'Day 1', value: 150 },
    { name: 'Day 2', value: 180 },
    { name: 'Day 3', value: 200 },
    { name: 'Day 4', value: 220 },
    { name: 'Day 5', value: shippedOrders },
  ];

  const chartData2 = [
    { name: 'Day 1', value: 30 },
    { name: 'Day 2', value: 40 },
    { name: 'Day 3', value: pendingOrders },
    { name: 'Day 4', value: 60 },
    { name: 'Day 5', value: 70 },
  ];

  const chartData3 = [
    { name: 'Day 1', value: 10 },
    { name: 'Day 2', value: 20 },
    { name: 'Day 3', value: 25 },
    { name: 'Day 4', value: 30 },
    { name: 'Day 5', value: newOrders },
  ];

  return (
    <div className="cards-section">
      <div className="card1">
        <h3>Shipped Orders<span>
              {" "}
              <FontAwesomeIcon icon={faShippingFast} />{" "}
            </span> </h3>
        <p>{shippedOrders}</p>
        <div className="chart">
          <ResponsiveContainer width="93%" height={190}>
            <LineChart data={chartData1}>
              <XAxis dataKey="name" />
              <YAxis />
              <CartesianGrid strokeDasharray="3 3" stroke="black" />
              <Tooltip 
               contentStyle={{
                width: '99px',
                height: '70px',
                backgroundColor: 'rgba(0, 0, 0, 0.8)',
                color: '#fff',
              }}
              labelStyle={{ color: '#fff', fontSize:'20px'}}/>
              <Line type="monotone" dataKey="value" stroke="rgba(79, 292, 292, 0.6)" strokeWidth={5} />
            </LineChart>
          </ResponsiveContainer>
        </div>
      </div>
      <div className="card2">
        <h3>Pending Orders <span>
              {" "}
              <FontAwesomeIcon icon={faCartShopping} />{" "}
            </span> </h3>
        <p>{pendingOrders}</p>
        <div className="chart">
          <ResponsiveContainer width="93%" height={190}>
            <LineChart data={chartData2}>
              <XAxis dataKey="name" />
              <YAxis />
              <CartesianGrid strokeDasharray="3 3" stroke="black" />
              <Tooltip 
              contentStyle={{
                width: '90px',
                height: '70px',
                backgroundColor: 'rgba(0, 0, 0, 0.8)',
                color: '#fff',
              }}
              labelStyle={{ color: '#fff', fontSize:'20px'}}/>
              <Line type="monotone" dataKey="value" stroke="rgba(255, 190, 192, 0.6)" strokeWidth={5} />
            </LineChart>
          </ResponsiveContainer>
        </div>
      </div>
      <div className="card3">
        <h3>New Orders<span>
              {" "}
              <FontAwesomeIcon icon={faCartPlus} />{" "}
            </span> </h3>
        <p>{newOrders}</p>
        <div className="chart">
          <ResponsiveContainer width="93%" height={190}>
            <LineChart data={chartData3}>
              <XAxis dataKey="name" />
              <YAxis />
              <CartesianGrid strokeDasharray="3 3" stroke="black"  />
              <Tooltip
              contentStyle={{
                width: '90px',
                height: '70px',
                backgroundColor: 'rgba(0, 0, 0, 0.8)',
                color: '#fff',
              }}
              labelStyle={{ color: '#fff', fontSize:'20px'}} />
              <Line type="monotone" dataKey="value" stroke="rgba(295, 296, 196, 0.7)" strokeWidth={5} />
            </LineChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
};

export default CardsSection;
